var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 67,
    viewBox: "0 0 64 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 66.0346L23.4318 59.8093H12.8409L9.56821 49.7369L1 43.5117L4.27271 33.4392L1 23.3666L9.56821 17.1415L12.8409 7.06889H23.4318L32 0.84375L40.5682 7.06902H51.1591L54.4318 17.1416L63 23.3667L59.7273 33.4393L63 43.5119L54.4318 49.737L51.1591 59.8096H40.5682L32 66.0346ZM16.5419 54.7154H25.0869L32 59.738L38.9131 54.7154H47.4581L50.0988 46.5887L57.0117 41.566L54.3713 33.4393L57.0117 25.3126L50.0988 20.2899L47.4581 12.1632H38.9131L32 7.14059L25.0869 12.1632H16.5419L13.9012 20.2899L6.98827 25.3126L9.6287 33.4393L6.98827 41.566L13.9012 46.5887L16.5419 54.7154ZM28.8483 44.245L18.9429 34.3398L22.5449 30.7377L28.8483 37.0412L41.4551 24.4344L45.0571 28.0364L28.8483 44.245Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 1.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUat);
export default __webpack_public_path__ + "static/media/UAT.ab106c7c1386e2a21337f429832529b9.svg";
export { ForwardRef as ReactComponent };